import { BaseContainerModel } from "../../base-container.model";
import {
  bl_fi_generic_doc_signature_RowClass,
  bl_fi_generic_doc_signature_RowInterface,
} from "../../../dbschema";

export class GenericDocSignatureContainerModel extends BaseContainerModel {
  bl_fi_generic_doc_signature: bl_fi_generic_doc_signature_RowInterface =
    new bl_fi_generic_doc_signature_RowClass();
}
